import { render, staticRenderFns } from "./ReviewListItem.vue?vue&type=template&id=031c5c68"
import script from "./ReviewListItem.vue?vue&type=script&lang=js"
export * from "./ReviewListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports